<div class="popupu_card ci_popup_card pop_active_card" id="divPlanReasonCalendarPopup" *ngIf="show">

  <div class="popup_inner">

      <a href="javascript:void(0)" (click)="planReasonCancel()" class="pc_close_btn"><i class="icon-close"></i></a>

      <div class="ci_popup_txt_area">

          <p class="cpta_img cpi_sm"><img src="assets/images/delete_icon.svg" alt=""></p>
              <h2>Meeting Deletion Reason</h2>
              
              <div class="mdc_date_tbox">

                  <div class="lcta_tbox"  [ngClass]="{'error': this.state.reason.iserr}">
                
                      <div class="lct_slt">
  
                          <select [(ngModel)]=this.state.reason.value id="drpreason" (click)="drpreason_Click()">
      
                              <option value="0">Select reason</option>
                              <ng-container *ngFor="let obj of this.reasonList">
                              
                              <option value="{{obj.reason_id}}">{{obj.reason}}</option>
                              
                              </ng-container>
      
                          </select>               
                  
                  
                      </div>
  
                      <span class="error_txt">{{this.state.reason.err_txt}}</span>
  
                      </div>
  
                      <div class="textarea_card" [ngClass]="{'error': this.state.reasonComments.iserr}">
  
                          <textarea name="" (keyup)="resonCheck()" [(ngModel)]=this.state.reasonComments.value placeholder="Reason"  cols="30" rows="10" ></textarea>
                          <span class="error_txt">{{this.state.reasonComments.err_txt}}</span>
                      </div>
                      
              </div>
        
          
      </div>

      <div class="ci_popup_btn_area">

          <button (click)="planReasonCancel()">CANCEL</button>

          <button (click)="planDeleteReasonYes()">SUBMIT</button>

      </div>

  </div>

</div>   